export const FORCE_CHANGE_PASSWORD_REQUEST = 'FORCE_CHANGE_PASSWORD_REQUEST';
export const FORCE_CHANGE_PASSWORD_SUCCESS = 'FORCE_CHANGE_PASSWORD_SUCCESS';
export const FORCE_CHANGE_PASSWORD_FAILURE = 'FORCE_CHANGE_PASSWORD_FAILURE';
